import React from 'react';
import ReactDOM from 'react-dom';

import '../lib/react-intl-use-intl-shim.js';
import AuthApp from '../components/auth/auth-app.jsx';

export default appTarget => {
    ReactDOM.render(<AuthApp />, appTarget);
};
